export function getJsonTemplate(json) {
    const result = {
      en: {}
    }
  
    function jsonTemplateHelper(jsonObj, parentKey = '') {
  
      const handleArrayObjTransformation = (keysValue, key) => {
        keysValue.forEach((arrayObj, index) => {
          Object.keys(arrayObj).forEach(objKey => {
            if (typeof arrayObj[objKey] === 'object') {
              jsonTemplateHelper(arrayObj[objKey], parentKey)
            } else {
              appendResult(arrayObj, objKey, index, key)
            }
          })
        })
      }
  
      const appendResult = (arrayObj, objKey, index, key) => {
        const updatedObjKey = transformKey(objKey)
        const updatedKey = transformKey(key)
        const updatedParentKey = transformKey(parentKey)
  
        if (!parentKey) {
          result['en'][updatedKey] = {
            ...result['en'][updatedKey],
            [`${updatedObjKey}_${index+1}`]: arrayObj[objKey]
          }
        } else {
          result['en'][updatedParentKey][updatedKey] = {
            ...result['en'][updatedParentKey][updatedKey],
            [`${updatedObjKey}_${index+1}`]: arrayObj[objKey]
          }
        }
      }
  
      const transformKey = (key) => {
        key = key.includes('CTA') ? key.replace('CTA', 'Cta') : key
        const toBeReplacedKey = key.replace(/([A-Z])/g, ",$1")
        return toBeReplacedKey.length > 0 ? toBeReplacedKey.split(',').map(word => word.toUpperCase()).join('_') : key.toUpperCase()
      }
  
      Object.keys(jsonObj).forEach(key => {
        const keysValue = jsonObj[key]
        if(!parentKey && !isKeyMultilingualSupported(key)) return
        if (typeof keysValue === 'object') {
          if (Array.isArray(keysValue)) {
            handleArrayObjTransformation(keysValue, key)
          } else {
            jsonTemplateHelper(keysValue, key)
          }
        } else {
          const updatedKey = transformKey(key)
          const updatedParentKey = parentKey && transformKey(parentKey)
  
          if (!parentKey) {
            result['en'][updatedKey] = jsonObj[key]
          } else {
            result['en'][updatedParentKey] = {
              ...result['en'][updatedParentKey],
              [updatedKey]: jsonObj[key]
            }
          }
        }
      })
    }
  
    jsonTemplateHelper(json)
    return result
  }

  const isKeyMultilingualSupported = (key) => {
      const allowedKeys = ['title', 'subtitle', 'supportText', 'initialFlows', 'agentDeskForm', 'endChat' , 'supportIconDetails', 'inactiveOverlay', 'calloutBubble', 'quickMenuOptions', 'restartChat', 'showWarning']    
      return allowedKeys.includes(key)
  }


/*

Usage of the getJsonTemplate function:
For supporting the translation of json config strings, we need to provide a generic object of translations to the i18n model.
This function will help in generating such syntax for only ENGLISH language. Since, rest of the other translations will be 
fetched from the S3 bucket which also will follow the same template structure.

The above function will take the bot's config json as input and will return the expected result upon looping through the
json's multilingual supported key.


For example: let's consider the below json.
json = {
    "title": "Hello, Need Help?",
    "subtitle": "I am your personal assistant",
    "supportText": "Need Support?",
    "isNetomiBrandingEnabled": true,
    "timeDelayBetweenMessageBubbles": 500,
    "initialFlows": {
        "header": "Ways I can help you",
        "flows": [
            {
                "name": "hi",
                "label": "hi"
            },
            {
                "name": "hello",
                "label": "hello"
            },
            {
                "name": "talk to agent",
                "label": "talk to agent"
            }
        ]
    },
    "endChat": {
        "idleTimeout": 120000,
        "sendTranscriptCta": "Send Transcript",
        "endChatButtonCta": "End Chat",
        "isSendTranscriptEnabled": true,
        "endChatQuery": "stop the conversation",
        "cancelButtonCta": "Cancel",
        "confirmButtonCta": "Confirm"
    },
    "customForms": {
        "FORM-0": {
            "header": "Submit a ticket with the Support Team",
            "formFields": [
                {
                    "label": "Name",
                    "field": "name",
                    "placeholder": "Enter Name",
                    "fieldType": "input",
                    "validations": [
                        "ifRequired",
                        "isName",
                        "isEmpty"
                    ]
                },
            ],
            "submitButtonText": "Submit",
            "formTitle": "Issue Ticket",
            "formSubmissionPostText": "submit the contact form",
            "rejectFormText": "Never mind, continue with AI Agent",
            "formSubmissionText": "Thank you for Providing your details. Our Human agent will contact you shortly via email"
        }
    },
    "calloutBubble": {
        "calloutBubbleEnabled": true,
        "intent": "callout bubbles",
        "attachments": [
            {
                "type": "Text",
                "text": "Hello"
            },
            {
                "type": "Text",
                "text": "My name is Katie"
            },
            {
                "type": "Text",
                "text": "How can i help you today ?",
                "quickReply": {
                    "options": [
                        {
                            "label": "Agent",
                            "metadata": "talk to agent",
                            "contentType": "text"
                        },
                        {
                            "label": "DOC",
                            "metadata": "order status",
                            "contentType": "text"
                        }
                    ]
                }
            }
        ]
    },
    "quickMenuOptions": [
        {
            "label": "horoscope",
            "text": "Can I talk to astrologer"
        },
        {
            "label": "External internal forms",
            "text": "sample 1"
        }
    ],
    "$LAST_TIME_SAVED": "2022-11-29T16:47:17+05:30"
}


The output will be:
result = {
    "en": {
        "TITLE": "Hello, Need Help?",
        "SUBTITLE": "I am your personal assistant",
        "SUPPORT_TEXT": "Need Support?",
        "INITIAL_FLOWS": {
            "HEADER": "Ways I can help you",
            "FLOWS": {
                "NAME_1": "hi",
                "LABEL_1": "hi",
                "NAME_2": "hello",
                "LABEL_2": "hello",
                "NAME_3": "talk to agent",
                "LABEL_3": "talk to agent"
            }
        },
        "END_CHAT": {
            "IDLE_TIMEOUT": 120000,
            "SEND_TRANSCRIPT_CTA": "Send Transcript",
            "END_CHAT_BUTTON_CTA": "End Chat",
            "IS_SEND_TRANSCRIPT_ENABLED": true,
            "END_CHAT_QUERY": "stop the conversation",
            "CANCEL_BUTTON_CTA": "Cancel",
            "CONFIRM_BUTTON_CTA": "Confirm"
        },
        "INACTIVE_OVERLAY": {
            "INACTIVE_OVERLAY_TIMEOUT": 18000000,
            "DESCRIPTION_TEXT": "Are you there, it's been more than 30 min since we last spoke.",
            "RESUME_BUTTON_TEXT": "Continue conversation",
            "RESTART_BUTTON_TEXT": "Restart conversation"
        },
        "CALLOUT_BUBBLE": {
            "CALLOUT_BUBBLE_ENABLED": true,
            "INTENT": "callout bubbles",
            "DELAY_FOR_FIRST_BUBBLE": 3000,
            "DELAY_IN_BETWEEN_BUBBLES": 1000,
            "ATTACHMENTS": {
                "TYPE_1": "Text",
                "TEXT_1": "Hello",
                "TYPE_2": "Text",
                "TEXT_2": "My name is Katie",
                "TYPE_3": "Text",
                "TEXT_3": "How can i help you today ?"
            },
            "OPTIONS": {
                "LABEL_1": "Agent",
                "METADATA_1": "talk to agent",
                "CONTENT_TYPE_1": "text",
                "LABEL_2": "DOC",
                "METADATA_2": "order status",
                "CONTENT_TYPE_2": "text",
            }
        },
        "QUICK_MENU_OPTIONS": {
            "LABEL_1": "horoscope",
            "TEXT_1": "Can I talk to astrologer",
            "LABEL_2": "External internal forms",
            "TEXT_2": "sample 1"
        }
    }
}

Only multilingual supported keys were added into the result. This result will be fed to the i18n model and upon calling the
translation for any of the strings, we need to pass the constant. 
For example: to get the translation of "Can I talk to astrologer" of Quick menu options, we need to provide 
QUICK_MENU_OPTIONS.LABEL_2 as constant. 

All such constants can be found in jsonConfigTemplate.js file.

*/
